import { useNavigate } from "react-router-dom";
import './BreadCrumb.scss';
import { IBreadCrumbProps } from "./Interfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faDashboard, faDatabase, faGear, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useSharedState } from "../services/WindowSizeService";
import onlineDevice from "../../../src/shared/images/OnlineDevices.svg";
import offlineDevice from "../../../src/shared/images/OfflineDevices.svg";
import classNames from "classnames";

const BreadCrumb = (props: IBreadCrumbProps) => {
    const windowSize$ = useSharedState();
    const navigate = useNavigate();
    const { currentPage, basePath, lastUpdated, firmwareVersion, deviceID } = props;

    // Navigate to home page
    const onClickHome = () => {
        navigate('/home');
    }
    // Converting the time/date into required format
    const toJSDate = (dateTime: any) => {
        if (dateTime) {
            var date = new Date(dateTime);
            // console.log(date.toLocaleDateString('en-GB'))
            let date1 = date.toLocaleDateString('en-GB');
            let reqTime = date.getTime();
            let temp = new Intl.DateTimeFormat('default',
                {
                    hour12: true,
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                }).format(reqTime);
            return (date1 + " " + temp);
        }
        else {
            return null;
        }
    }

    return (
        <nav className="page-navs nav-style center-align p-0">
            <div className="align-items-center nav-wrapper w-100">
                <div className="row m-0">
                    <div className="row align-items-center col-12 p-0">
                        {currentPage &&
                            <div className="col-sm-12 col-md-3 col-lg-3 d-flex">
                                <div className="base-path menu-link-hoverable" onClick={onClickHome}>
                                    <FontAwesomeIcon icon={faGear} />
                                </div>
                                <div className="breadcrumb-font ml-2">
                                    <span className="breadcrumb-label">Device Type : </span>
                                    {currentPage}
                                </div>
                            </div>
                        }
                        {deviceID &&
                            <div className={classNames("col-sm-12 col-md-3 col-lg-3",
                                {
                                    "d-none": windowSize$ === "sm" || windowSize$ === "xs",
                                    "d-flex": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                                })}>
                                <div className="base-path menu-link-hoverable">
                                    <FontAwesomeIcon icon={faDashboard} />
                                </div>
                                <div className="breadcrumb-font ml-2">
                                    <span className="breadcrumb-label">Device ID : </span>{deviceID}
                                </div>
                            </div>
                        }
                        {firmwareVersion &&
                            <div className={classNames("col-sm-12 col-md-3 col-lg-3",
                                {
                                    "d-none": windowSize$ === "sm" || windowSize$ === "xs",
                                    "d-flex": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                                })}>
                                <div className="base-path menu-link-hoverable">
                                    <FontAwesomeIcon icon={faDatabase} />
                                </div>
                                <div className="breadcrumb-font ml-2">
                                    <span className="breadcrumb-label">Firmware Version : </span>{firmwareVersion}
                                </div>
                            </div>
                        }
                        <div className="refresh-time col-sm-12 col-md-3 col-lg-3">
                            <div className={classNames("mt-1 d-flex",
                                {
                                    // "d": windowSize$ === "sm" || windowSize$ === "xs",
                                    "last-updated-class": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                                })}>
                                <div className="base-path menu-link-hoverable">
                                    {lastUpdated?.device_status && lastUpdated?.device_status === "Offline" ?
                                        <img src={offlineDevice} className="device-status-class" alt="DataLogger" /> :
                                        <img src={onlineDevice} className="device-status-class" alt="DataLogger" />
                                    }
                                    {/* <FontAwesomeIcon icon={faClock} /> */}
                                </div>
                                {lastUpdated ?
                                    <div className="breadcrumb-font ml-2" >
                                        <span className="breadcrumb-label">{lastUpdated?.status_message}</span> : {toJSDate(lastUpdated?.last_heartbeat)}
                                    </div>
                                    :
                                    <div className="d-flex ml-2">
                                        <div>Loading...</div>
                                        <div className="spinner-border text-dark ml-2" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </nav>
    )

}

export default BreadCrumb;